import React, { Component } from 'react';
import { BrandId, getBrandIdFromHostname } from '@delta-defense/delta-utils';
import '../AdditionalInfo/AdditionalInfo.scss';

class EmailChange extends Component {
  render() {
    const brandId = getBrandIdFromHostname() || BrandId.USCCA;
    return (
      <div className="email-change">
        <p className="font-weight-bold mt-0 mb-2">Has your email address changed?</p>
        <p className="mt-0 mb-0">
          If you no longer have access to the email address linked to your {brandId !== BrandId.CABELAS && 'USCCA'} Account, you can
          contact our Customer Service Team at{' '}
          {brandId !== BrandId.CABELAS ?
            <a href="tel:8006749779" className="email-change__link" aria-label="Customer Service Number">800-674-9779</a>
            :
            <a href="tel:8553221095" className="email-change__link" aria-label="Customer Service Number">855-322-1095</a>
          }
          {' '}
          to help you access your {brandId !== BrandId.CABELAS && 'USCCA'} account.
        </p>
      </div>
    );
  }
}

export default EmailChange;
